import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { CurrentUser } from './security/current-user.model';
import { CurrentUserService } from "./security/current-user.service";
import { MatDialog, MatDialogConfig } from "@angular/material";

declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    constructor(public currentUserService: CurrentUserService, public dialog: MatDialog) {
    }
  
    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts